module.exports = __webpack_public_path__ + "img/music.394bc0f8.gif";